// Filename: views/layout/supervisor.js
define('views/modules/dashboard/graph/graph-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // models
    'models/graph/graph',
    'collections/calendar/personal-data/personal-data-types',
    // Views
    'views/parts/chart/chart-line',
    'views/parts/form/select',
    // events
    'services/events/calendar-events',
    // mixins
    'mixins/graph/graph-mixin',
    // Templates
    'text!templates/modules/dashboard/graph/graph-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // models
    MGraph,
    CPersonalDataTypes,
    // Views
    VChartLine,
    VSelect,
    // events
    CalendarEvents,
    // mixins
    GraphMixin,
    // Templates
    TGraphContent
) {

    var VGraphContent = Backbone.View.extend(_.extend({
        template: TGraphContent,

        regions: {
            chart: ".chart",
            series: ".select-graph-series",
        },

        initialize: function(opt) {
            opt = opt || {};

            var model = this.model = new MGraph();

            _.extend(this, {
                config: model.getDefaultConfig(),
                personalData: new CPersonalDataTypes(),
                profile: opt.profile
            });

            var collection = this.collection = this.model.getDefaultSeries(),
                view = this.view = {
                    series: new VSelect({
                        labelposition: "top",
                        option: { label: 'label', value: 'value' },
                        attribute: 'type',
                        model: this.config,
                        addClass: 'btn-sm',
                        collection: collection,
                        onChange: this.onSeriesChange,
                        context: this,
                    }),
                    chart: new VChartLine({
                        data: this.data,
                        resize: false,
                        chart: {
                            options: {
                                scales: {
                                    xAxes: {
                                        scaleLabel: {
                                            display: false,
                                        }
                                    },
                                    yAxes: {
                                        ticks: {
                                            beginAtZero: false
                                        }
                                    }
                                }
                            }
                        }
                    }),
                };

            this.listenTo(this.personalData, { 'sync': this.onPersonalDataSync })
                .listenTo(this.profile, { 'sync': this.onProfileSync })
                .listenTo(CalendarEvents, 'newItemToday', this.onNewItemToday);

            var dates = this.dates = new Backbone.Model({
                from: moment().subtract(7, 'days'),
                to: moment().add(1, 'days')
            });

            this.initGraph();
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.chart, zone.$chart)
                .assign(view.series, zone.$series);

            this.personalData.fetch();
            this.loadGraph();

            return this;
        },

        initGraph: function() {
            var model = this.model,
                dates = this.dates;
            model.setRequest({
                type: 'distance',
                frequency: 'daily',
                startDate: dates.get('from').format('YYYY-MM-DD'),
                endDate: dates.get('to').format('YYYY-MM-DD')
            });

            this.datasetUnit = this.getDatasetUnit(this.view.series.getValue() || 'waistline');
        },

        renderGraph: function() {
            var labels = [];
            this.data = [];

            _.each(this.model.attributes, function(value, key) {
                this.data.push(value);
                labels.push(key);
            }, this);

            this.title = this.view.series.getLabel();
            
            this.view.chart.updateChart({
                labels: labels,
                data: this.data,
                unit: 'day',
                min: this.dates.get('from'),
                max: this.dates.get('to'),
                xAxisUnit: 'day',
                datasetUnit: this.datasetUnit,
                yAxesBeginAtZero: !this.data.some(function(value) { return value != 0 })
            });
        },

        onSeriesChange: function(model, value) {
            this.model.setType(value);
            this.datasetUnit = this.getDatasetUnit(value);
            this.loadGraph();
        },

        onResize: function(e, width) {
            var view = this.view.chart;
            if (view.onResize) {
                view.onResize(width);
            }
        },

        onNewItemToday: function() {
            setTimeout(function() {
                this.loadGraph();
            }.bind(this), 1000);
        }

    }, GraphMixin));

    return VGraphContent;

});

